import React, { useMemo, useState } from 'react';
import { SegmentChatContext } from './SegmentChat.Context';

type Props = {
  children: React.ReactNode;
};

export const SegmentChatContainer = ({ children }: Props) => {
  const [segmentChatStatus, setSegmentChatStatus] = useState<boolean>(false);
  const [segmentIconUrl, setSegmentIconUrl] = useState<string | null | undefined>(undefined);
  const [segmentIconsCache, setSegmentIconsCache] = useState<Record<string, string | undefined>>({});

  const ctx = useMemo(
    () => ({
      segmentChatStatus,
      setSegmentChatStatus,
      segmentIconUrl,
      setSegmentIconUrl,
      segmentIconsCache,
      setSegmentIconsCache,
    }),
    [segmentChatStatus, segmentIconUrl, segmentIconsCache]
  );

  return <SegmentChatContext.Provider value={ctx}>{children}</SegmentChatContext.Provider>;
};
